import {
    READ_PERM,
    TRAILER_STATUS_TYPE_TIPPY_TEXT,
    TRUCK_STATUS_AVAILABLE,
    TRUCK_STATUS_BOOKED,
    TRUCK_STATUS_ON_LOAD,
    TRUCK_STATUS_OUT_OF_SERVICE,
    TRUCK_STATUS_RETIRED,
    TRUCK_STATUS_SOLD,
    TRUCK_STATUS_TYPE_TIPPY_TEXT,
    TRUCK_STATUS_TYPES,
    UPDATE_PERM
} from "../../../../util/util-constants";
import {ArrowTopRightOnSquareIcon} from "@heroicons/react/24/outline";
import Tippy from "@tippyjs/react";
import React from "react";
import {checkPerm, classNames, getSystemName, openInNewTab} from "../../../../common/util/util-helpers";
import Resources from "../../../../data/services/resources";
import Badge from "../../../../common/components/badge";
import Env from "../../../../util/env";

export default function TrucksTableBadge({item, itemType, translate, addClass, onOutOfServiceClick}) {

    if (!item || !item?.StatusID) {
        return null;
    }
    const isOutOfService = item.StatusID === TRUCK_STATUS_OUT_OF_SERVICE && checkPerm(Resources.TruckServices, READ_PERM);
    const canFollowLink = (!!item.StatusID && !!item.OnLoadID) || isOutOfService;

    return (
        <Tippy
            disabled={!item.StatusID}
            content={<div>{
                itemType === 'trailer' ? translate(TRAILER_STATUS_TYPE_TIPPY_TEXT[item.StatusID]) : translate(TRUCK_STATUS_TYPE_TIPPY_TEXT[item.StatusID])
            }
                {item?.RetiredNotes && (
                    <p className="whitespace-pre-wrap"><span className="font-bold">Note: </span>{item?.RetiredNotes}</p>
                )}
            </div>}
        >
            <div>
                <Badge
                    addClass={classNames(addClass, isOutOfService ? "cursor-pointer hover:bg-yellow-700" : undefined)}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (checkPerm(Resources.LoadInfo, UPDATE_PERM) && canFollowLink && (item.StatusID === TRUCK_STATUS_BOOKED || item.StatusID === TRUCK_STATUS_ON_LOAD)) {
                            if (getSystemName() !== 'main') {
                                openInNewTab(Env.getTruckMainUrl(`/loads/info/${item.OnLoadID}`));
                            } else {
                                window.open(`${window.location.origin}/loads/info/${item.OnLoadID}`, '_blank');
                            }
                        }

                        if (onOutOfServiceClick && isOutOfService) {
                            onOutOfServiceClick(item);
                        }
                    }}
                    type={getBadgeClass(item.StatusID)}>
                    <div className="flex">
                        {TRUCK_STATUS_TYPES[item.StatusID]}
                        {canFollowLink && (item.StatusID === TRUCK_STATUS_BOOKED || item.StatusID === TRUCK_STATUS_ON_LOAD) && (
                            <ArrowTopRightOnSquareIcon
                                className={'w-5 h-5 ml-4'}
                            />
                        )}
                    </div>
                </Badge>
            </div>
        </Tippy>
    )
}

const getBadgeClass = (type) => {
    switch (type) {
        case TRUCK_STATUS_AVAILABLE:
            return "success"
        case TRUCK_STATUS_BOOKED:
        case TRUCK_STATUS_ON_LOAD:
            return "primary"
        case TRUCK_STATUS_SOLD:
        case TRUCK_STATUS_RETIRED:
            return "danger"
        case TRUCK_STATUS_OUT_OF_SERVICE:
            return "warning"
        default:
            return "danger"
    }
}
